import ReactComponent from '../app/ReactComponent'
import {$app} from '../app'
import {Button, Col, Row, Space, Spin} from 'antd'
import {Link, redirect} from "react-router-dom"
import dayjs from 'dayjs'
import {parsePhoneNumber} from 'awesome-phonenumber'
import OverlayContent from '../components/layout/OverlayContent'
import ContactDetail from '../components/cards/ContactDetail'
import FixedHeaderPageContainer from './FixedHeaderPageContainer'
import PrivacyPolicyContent from '../components/parts/PrivacyPolicyContent'
import VOPContent from '../components/parts/VOPContent'
import {
  getAccountActiveCard,
  getLastAppliedVoucher,
  getLastVisitForBasicStatus,
  getLastVisitForLobsterFriendStatus,
  getPoints,
  getPointsOverview,
  getTotalVisitsForBasicStatus,
  getTotalVisitsForLobsterFriendStatus,
  isAccountLobsterFriend
} from '../resources/AccountResource'
import Reader from '../components/helpers/reader/Reader'
import App from '../app/App'

export default class OtherPage extends ReactComponent {
  state = {
    loading: false,
    loading_logout: false,
    customer: {},
    activeFAQ: false,
    activeAboutApp: false,
    activeContactDetail: false,
    activePrivacyPolicy: false,
    activeVOP: false,
    activeReader: false,
    activeAccountUpdate: false,

    birthdate: null,
    card_number: '',
    points: {},
    status: '',
    last_visit_date: null,
    total_visits: null,
    applied_vouchers_total_count: null
  }

  async componentDidMount() {

    //console.log(this.props.$auth.isAuthorized)
    //console.log(await this.props.$auth.isAuthorized)
    if(await this.props.$auth.isAuthorized) {
      void this.getAccountData()

    }

  }

  async getAccountData() {
    let total_visits, last_visit_date

    void this.updateState({loading: true})

    const customer = await $app.$api({
      action: 'carecloud_user_api'
    })

    const isLobsterFriend = await isAccountLobsterFriend()

    if(isLobsterFriend) { // BASIC STATUS

      const {visit: last_visit, total_items = 0} = (await getLastVisitForLobsterFriendStatus())

      last_visit_date = dayjs(last_visit.payment_time).format('D.M.YYYY')
      total_visits = total_items

    } else { // LOBSTER FRIEND STATUS

      const {visit: last_visit, total_items = 0} = (await getLastVisitForBasicStatus())

      last_visit_date = last_visit ? dayjs(last_visit.created_at).format('D.M.YYYY') : null
      total_visits = total_items

    }

    const card = await getAccountActiveCard()

    const {total_items: applied_vouchers_total_count} = await getLastAppliedVoucher()

    const points = await getPointsOverview()

    const birthdate = this.state.customer?.personal_information?.birthdate ? dayjs(this.state.customer?.personal_information?.birthdate).format('D.M.YYYY') : "Nemáte vyplněné"

    void this.updateState({
      customer,
      birthdate,
      card_number: card?.number,
      status: isLobsterFriend ? 'Lobster friend' : 'Basic',
      points,
      last_visit_date,
      total_visits,
      applied_vouchers_total_count,
      loading: false
    })

  }

  phoneNumber() {
    try {
      if(this.state.customer?.personal_information?.phone !== undefined)
        return parsePhoneNumber(this.state.customer?.personal_information?.phone, {regionCode: 'CZ'}).number.international
    } catch (e) {
      console.log(e)
      return ''
    }
  }

  handleLogout() {
    void this.updateState({loading_logout: true})
    this.props.$auth.logout()
    redirect('/')
  }

  handleOpenContactDetail() {
    void this.updateState({activeContactDetail: true})
  }

  handleCloseContactDetail() {
    void this.updateState({activeContactDetail: false})
  }

  async handleSubmitAccountUpdateForm() {
    void this.updateState({loading: true})

    const customer = await $app.$api({
      action: 'carecloud_user_api'
    })

    void this.updateState({
      customer,
      loading: false,
      activeAccountUpdate: false
    })

  }

  handleCloseAccountUpdateForm() {
    void this.updateState({activeAccountUpdate: false})
  }

  render() {
    return (
      <Spin spinning={this.state.loading} size="large">
        <section className="full-height">
          <Row className="container centered" justify="center">

            {
              this.props.$auth.isAuthorizedState ?

                <Col span={24}>
                  <h1 className="main-title">
                    {this.state.customer.personal_information?.first_name || ''}<br/>
                    {this.state.customer.personal_information?.last_name || ''}
                  </h1>
                  <p><strong>Tel.:</strong> {this.phoneNumber()}</p>
                  <p><strong>E-mail:</strong> {this.state.customer?.personal_information?.email}</p>
                  <p><strong>Datum narození:</strong> {this.state.birthdate}</p>
                  <br/>

                  <p><strong>Status:</strong> {this.state.status}</p>
                  <p><strong>Poslední návštěva:</strong> {this.state.last_visit_date}</p>
                  <p><strong>Počet návštěv:</strong> {this.state.total_visits}</p>
                  <br/>

                  <p><strong>Počet získaných odměn:</strong> {this.state.applied_vouchers_total_count}</p>
                  <p><strong>Celkový získaný cashback:</strong> {this.state.points.earned_points}</p>
                  <p><strong>Využitý cashback:</strong> {this.state.points.redeemed_points}</p>
                  <br/>

                  <p><strong>Aktuální stav cashback konta:</strong> {this.state.points.available_points}</p>
                  {!this.state.loading && this.state.card_number && <p><strong>Číslo karty:</strong> {this.state.card_number}</p> }
                  <br/>
                </Col>

                :

                <Col span={24}>
                  <h1 className="main-title">Více</h1>
                </Col>
            }

            <Col span={22} className="mb-2">
              <br/>

              <Space direction="vertical" style={{width: '100%'}} size="middle">

                {this.props.$auth.isAuthorized &&

                  <Link to="/account-update">
                    <Button
                      type="primary"
                      block
                    >Úprava údajů</Button>
                  </Link>
                }

                <Button
                  type="primary"
                  block
                  className="_secondary _primary-text"
                  onClick={() => this.handleOpenContactDetail()}
                >Kontakty</Button>

                <Button
                  type="primary"
                  block
                  onClick={() => {
                    void this.updateState({activeFAQ: true})
                  }}
                >Informace a FAQ</Button>

                <Button
                  type="primary"
                  block
                  onClick={() => {
                    void this.updateState({activeVOP: true})
                  }}
                >Obchodní podmínky</Button>


                <Button
                  type="primary"
                  block
                  onClick={() => {
                    void this.updateState({activePrivacyPolicy: true})
                  }}
                >Zásady ochrany soukromí</Button>

                <Button
                  type="primary"
                  block
                  onClick={() => {
                    void this.updateState({activeAboutApp: true})
                  }}
                >O aplikaci</Button>

                <Button
                  type="primary"
                  block
                  onClick={() => {
                    void this.updateState({activeReader: true})
                  }}
                >Čtečka QR kódu</Button>
                <Reader active={this.state.activeReader} onClose={(res) => {
                  App.$toast("Hodnota QR: " + res)
                  void this.updateState({activeReader: false})
                }}/>

                {
                  this.props.$auth.isAuthorizedState &&

                  <Button
                    type="primary"
                    block
                    onClick={() => {
                      this.handleLogout()
                    }}
                    icon={<Spin spinning={this.state.loading_logout}/>}
                  >Odhlásit</Button>

                }

              </Space>
            </Col>
          </Row>

          <OverlayContent
            active={this.state.activeFAQ}
            onClose={() => {
              void this.updateState({activeFAQ: false})
            }}
          >
            <h2 className="main-title">Informace a FAQ</h2>
            <p>Tu bude info o aplikaci</p>
          </OverlayContent>

          <OverlayContent active={this.state.activeVOP} onClose={() => {
            void this.updateState({activeVOP: false})
          }}>
            <VOPContent/>
          </OverlayContent>

          <OverlayContent
            active={this.state.activePrivacyPolicy}
            onClose={() => {
              void this.updateState({activePrivacyPolicy: false})
            }}>
            <PrivacyPolicyContent/>
          </OverlayContent>

          <OverlayContent
            active={this.state.activeAboutApp}
            onClose={() => {
              void this.updateState({activeAboutApp: false})
            }}
          >
            <h2 className="main-title">O aplikaci</h2>
            <p>Tu bude info o aplikaci</p>
          </OverlayContent>

          <ContactDetail
            active={this.state.activeContactDetail}
            onClose={() => this.handleCloseContactDetail()}/>

        </section>
      </Spin>
    )
  }
}